<script setup>
import KdContainer from "./kdContainer.vue";
</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="165px">
      <div v-for="(sItem, index) in form.marketVehiclesList" :key="index">
        <div class="suggestionTitle">
          <div>{{ sItem.staffName }}</div>
        </div>
        <div>
          <el-form-item
            label="市场物料处置及补发方案"
            :prop="`marketVehiclesList.${index}.inventoryVehicleDisposalSolution`"
            :rules="rules.inventoryVehicleDisposalSolution"
          >
            <el-input
              :disabled="sItem && sItem.inventoryVehicleDisposalSolution != ''"
              placeholder="请输入市场物料处置及补发方案"
              v-model="sItem.inventoryVehicleDisposalSolution"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`marketVehiclesList.${index}.permanentSolutionFile`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.permanentSolutionFile"
            ></file-upload-list>
          </el-form-item>
        </div>
      </div>
      <el-form-item label="市场物料处理情况" prop="inventoryVehicleHandStatusMessage">
        <el-input  :disabled="this.taskDefKey == 'Activity_1jrizcd' && this.inventoryVehicleHandStatusMessage != ''"
                    v-model="inventoryVehicleHandStatusMessage" type="textarea" placeholder="请输入市场物料处理情况"
                   :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
      </el-form-item>

      <div v-if="this.taskDefKey == 'Activity_1jrizcd'">
        <el-form-item label="索赔结果" prop="handSuggestion">
          <el-input placeholder="请输入索赔结果" v-model="form.handSuggestion"
                    type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </div>

      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
          >通过</el-button
        >
        <el-button v-if="this.taskDefKey == 'Activity_1jrizcd'" class="lang-but" type="danger" @click="auditRejectBtClick"
          >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss"></style>
<script>
import { baseURL } from "../../util/url";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 15.2-QE确认永久方案和计划改善时间
 */
export default {
  name: "kdServeInventoryHandStatusAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId: String,
    questionId: String,
    taskDefKey: String,
    inventoryVehicleHandStatusMessage: String,
    marketVehiclesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible: false,
      auditPassDialogVisible: false,
      form: {
        inventoryVehicleHandStatusMessage: "",
        marketVehiclesList: [
          {
            inventoryVehicleDisposalSolutionFiles:[],
            marketVehicleDisposalSolutionFiles:[],
            hasInventoryVehicle: 1,
            hasMarketVehicle: 1,
            inventoryVehicleDisposalSolution: "",
            marketVehicleDisposalSolution: "",
            inventoryVehicleHandStatusMessage: "",
            inventoryVehicleHandStatusMessageFiles: [],
          },
        ],
        rejectReason: "",
        handSuggestion: "",
        handSuggestionFiles: [],
        auditText: "",
      },
      userOptions: [],
      rules: {
        reasonAnalyst: [
          {
            required: true,
            message: "根因分析不能为空",
            trigger: ["blur", "change"],
          },
        ],
        permanentSolution: [
          {
            required: true,
            message: "永久方案不能为空",
            trigger: ["blur"],
          },
        ],
        planBreakpointTime: [
          {
            required: true,
            message: "实际断点时间不能为空",
            trigger: ["blur"],
          },
        ],
        userId: [
          {
            required: true,
            message: "驳回责任单位人员不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  methods: {
    auditPassBtClick() {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        faultVideoList: this.form.handSuggestionFiles,
        variables: {
          approval: true,
          inventoryVehicleHandStatusMessage: this.inventoryVehicleHandStatusMessage,
          handSuggestion: this.form.handSuggestion,
        },
      };
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.form.rejectItems= [
        {
          userId: "",
          rejectReason: "",
        }
      ];
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      });
    },
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    addRejectUser() {
      if (this.form.rejectItems.length > this.form.marketVehiclesList.length) {
        this.$DonMessage.warning("添加驳回数量超过上限！");
        return;
      }
      this.form.rejectItems.push({
        userId: "",
        rejectReason: "",
      });
    },
    delRejectUser(index) {
      this.form.rejectItems.splice(index, 1);
    },
  },
  mounted() {
    if (this.marketVehiclesList) {
      this.form.marketVehiclesList = this.marketVehiclesList;
      this.userOptions = this.marketVehiclesList;
    }
  },
};
</script>
